import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ChargeComment } from '../interfaces/charge-comment';
import { Observable } from 'rxjs';
import { Constants } from '../helpers';
import { map } from 'rxjs/operators';

@Injectable()
export class ChargeCommentService {
	constructor(private http: HttpClient) {}

	/**
	 * Add a comment to a charge
	 * -
	 * Charge comment can be Quote & Office or Site comments
	 * @param data
	 */
	public addChargeComment(data: { id: string, title: string, message: string, type: string, company: string, projectId: string }): Observable<ChargeComment> {
		return this.http.post<ChargeComment>(`${Constants.BASE_API_URL}/charge-comment/new-comment`, data);
	}

	public updateChargeComment(id: string, data: { title: string, message: string }): Observable<ChargeComment> {
		return this.http.put<ChargeComment>(`${Constants.BASE_API_URL}/charge-comment/${id}`, data);
	}

	/**
	 * Get comments for a charge
	 * @param companyId
	 * @param type
	 */
	public getChargeComments(companyId: string, type: string): Observable<ChargeComment[]> {
		return this.http
			.get<{ status: boolean; comments: ChargeComment[]; message: string }>(
				`${Constants.BASE_API_URL}/charge-comment/comments`,
				{ params: { company: companyId, type: type } as any }
			)
			.pipe(map(res => res.comments ?? []));
	}

	/**
	 * Delete a comment from a charge
	 * @param commentId
	 */
	public deleteChargeComment(id: string): Observable<{ success: boolean }> {
		return this.http.delete<{ success: boolean }>(`${Constants.BASE_API_URL}/charge-comment/${id}`);
	}
}
